import { AuthenticationModalKind } from "../AuthenticationModalKind.js";

export function getNewCodePath(email?: string): string {
	const searchParams = new URLSearchParams();
	searchParams.set("modal", AuthenticationModalKind.ResendConfirmationCode);
	if (email?.trim()) {
		searchParams.set("email", email.trim());
	}
	return `?${searchParams}`;
}
